export enum AppraisalStatus {
  NotSet = 'NotSet',
  Unclaimed = 'Unclaimed',
  Active = 'Active',
  Expired = 'Expired',
  Deleted = 'Deleted',
  Completed = 'Completed',
  Rejected = 'Rejected'
}

export type AppraisalSummary = {
  acquisitionId?: number;
  acquisitionName?: string;
  appraisalId: number;
  color?: string;
  expirationDisplayDate: string;
  expired?: boolean;
  isDrivable: boolean;
  isOfferAccepted: boolean;
  make?: string;
  model?: string;
  status: AppraisalStatus;
  trim?: string;
  vehicleImages?: { mobileImage?: string };
  vehicleId?: number;
  vehicleValue?: number;
  year?: number;
};

export enum TileTypes {
  Active = 'Active',
  ActionRequired = 'Action Required',
  OfferExpired = 'Offer Expired',
  OfferPending = 'Offer Pending'
}
